const API_BASE_URL = import.meta.env.VITE_API_URL || 'http://154.40.44.143:5000/api'

class ApiService {
  constructor() {
    this.baseURL = API_BASE_URL
  }

  async request(endpoint, options = {}) {
    const url = `${this.baseURL}${endpoint}`
    const config = {
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
      ...options,
    }

    try {
      const response = await fetch(url, config)
      const data = await response.json()

      if (!response.ok) {
        throw new Error(data.message || '请求失败')
      }

      return data
    } catch (error) {
      console.error('API请求错误:', error)
      throw error
    }
  }

  // 新闻相关API
  async getNews(params = {}) {
    const queryString = new URLSearchParams(params).toString()
    return this.request(`/news?${queryString}`)
  }

  async getNewsById(id) {
    return this.request(`/news/${id}`)
  }

  async getNewsCategories() {
    return this.request('/news/categories/list')
  }

  // 招聘相关API
  async getCareers(params = {}) {
    const queryString = new URLSearchParams(params).toString()
    return this.request(`/careers?${queryString}`)
  }

  async getCareerById(id) {
    return this.request(`/careers/${id}`)
  }

  async applyCareer(id, applicationData) {
    return this.request(`/careers/${id}/apply`, {
      method: 'POST',
      body: JSON.stringify(applicationData),
    })
  }

  async getDepartments() {
    return this.request('/careers/departments/list')
  }

  async getCareerTypes() {
    return this.request('/careers/types/list')
  }

  // 产品相关API
  async getProducts(params = {}) {
    const queryString = new URLSearchParams(params).toString()
    return this.request(`/products?${queryString}`)
  }

  async getProductBySlug(slug) {
    return this.request(`/products/${slug}`)
  }

  // 解决方案API
  async getSolutions() {
    return this.request('/solutions')
  }

  // 联系相关API
  async submitContactForm(formData) {
    return this.request('/contact/submit', {
      method: 'POST',
      body: JSON.stringify(formData),
    })
  }

  async getContactInfo() {
    return this.request('/contact/info')
  }

  // 投资相关API
  async getInvestmentData() {
    return this.request('/investment')
  }

  // 健康检查
  async healthCheck() {
    return this.request('/health')
  }
}

const apiService = new ApiService()
export { apiService }
export default apiService